import ClaimRulePage from "@/main/components/features/claim_rule/ClaimRulePage"

const ClaimRule = () => {
	return <ClaimRulePage />
}

export default ClaimRule
